export const PHOTO_REVIEW_STATUS = Object.freeze({
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
});

export const normalizePhotoReviewStatus = (status) =>
  Object.values(PHOTO_REVIEW_STATUS).includes(status) ? status : null;

export const buildPhotoReviewStatusExistsClause = ({
  photoAlias = "ppa",
  status,
  reviewReqIdInClause = "",
} = {}) => {
  const normalizedStatus = normalizePhotoReviewStatus(status);
  if (!normalizedStatus) return "";

  const reviewRequestFilter = reviewReqIdInClause
    ? `
      AND EXISTS (
        SELECT 1
        FROM review_request_info_review_image_bind rririb_request
        JOIN review_request_review_request_info_bind rrpb_request
          ON rrpb_request.review_request_info_id = rririb_request.review_request_info_id
        WHERE rririb_request.review_image_info_id = rii.id
          ${reviewReqIdInClause.replace(/rrpb\./g, "rrpb_request.")}
      )`
    : "";

  return `
    EXISTS (
      SELECT 1
      FROM review_image_info rii
      JOIN review_image_info_photo_review_result_bind prb
        ON prb.review_image_info_id = rii.id
      JOIN photo_review_result pr
        ON pr.id = prb.photo_review_result_id
      WHERE rii.photo_of_power_asset_id = ${photoAlias}.id
        AND pr.status = '${normalizedStatus}'
        ${reviewRequestFilter}
    )`;
};
